/*
 dashboard

 This component represents a single dashboard object.

 */

import ko from 'knockout';
import _ from 'lodash';
import { widget } from './widget';

ko.components.register('dashboard', {
    viewModel: dashboard,
    template: {
        element: 'dashboard-template'
    }
});


export function dashboard(params) {

    var self = this;

    params = params || {};

    var data = params && params.data ? params.data : params;

    if (data instanceof dashboard)
        return data;

    //Base props
    self.id = ko.observable(_.defaultIfNullOrUndefined(data.id, -1));
    self.title = ko.observable(_.defaultIfNullOrUndefined(data.title, ''));
    self.userId = ko.observable(_.defaultIfNullOrUndefined(data.userId, -1));
    self.widgets = ko.observableArray([]);
    self.defaultDashboard = ko.observable(_.defaultIfNullOrUndefined(data.defaultDashboard, 0));
    self.isDashboardOwner = ko.observable(_.defaultIfNullOrUndefined(data.isDashboardOwner, false));
    self.canDelete = ko.observable(_.defaultIfNullOrUndefined(data.canDelete, true));
    self.editDashboardsFeatureEnabled = ko.observable(_.defaultIfNullOrUndefined(data.editDashboardsFeatureEnabled, false));
    self.editDashboardWidgetsFeatureEnabled = ko.observable(_.defaultIfNullOrUndefined(data.editDashboardWidgetsFeatureEnabled, false));
    self.hasCachedWidgets = ko.observable(_.defaultIfNullOrUndefined(data.hasCachedWidgets, false));
    self.widgetLoadingDelay = ko.observable(_.defaultIfNullOrUndefined(data.widgetLoadingIntervalMilliseconds, 100));
    self.openQueryDialog = data.openQueryDialog;

    var reportsRepo = data.reportsRepo;
    var dashboardsRepo = data.dashboardsRepo;

    //Public functions

    //Add a widget
    self.addWidget = function () {

        var newWidget = new widget({
            editMode: true,
            dashboard: self,
            dashboardsRepo: dashboardsRepo,
            reportsRepo: reportsRepo,
            dashboardId: self.id()
        });
        self.widgets.unshift(newWidget);
    }

    self.reloadWidget = function (widgetToReload, event) {

        //Find the index of the widget with the specified element id
        var elementId = widgetToReload.domElementId();
        var widgetIndex = _.findIndex(self.widgets(), function (w) { return w.domElementId() == elementId; });

        if (widgetIndex < 0)
            return;

        //Get the widget id
        var widgetId = self.widgets()[widgetIndex].id();

        //Go back to the api and get a fresh copy of the widget.
        if (dashboardsRepo) {
            dashboardsRepo.getWidget(widgetId).then(
                function (result) {

                    if (result) {
                        result.editMode = false;
                        result.dashboard = self;
                        result.dashboardsRepo = dashboardsRepo;
                        result.reportsRepo = reportsRepo;
                        result.isDashboardOwner = self.isDashboardOwner();
                        result.editDashboardWidgetsFeatureEnabled = self.editDashboardWidgetsFeatureEnabled();

                        var newWidget = new widget(result);

                        //Remove old widget
                        self.widgets.splice(widgetIndex, 1);

                        //Insert new widget
                        self.widgets.splice(widgetIndex, 0, newWidget);
                    }
                },
                function (errorResult) {
                }
            );
        }
    }

    self.deleteWidget = function (widget, event) {

        //Find the index of the widget with the specified element id
        var elementId = widget.domElementId();
        var widgetIndex = _.findIndex(self.widgets(), function (w) { return w.domElementId() == elementId; });

        if (widgetIndex < 0)
            return;

        //Get the widget id
        var widgetId = self.widgets()[widgetIndex].id();

        //Remove the widget from the dashboard
        self.widgets.splice(widgetIndex, 1);

        //Remove the widget from the api      
        if (widgetId >= 0) {

            if (dashboardsRepo) {
                dashboardsRepo.deleteWidget(widgetId).then(
                    function () {
                        //success
                    },
                    function (errorResult) {
                    }
                );
            }
        }
    }

    //Private functions
    var init = function (data) {

        //Load the widgets
        if (data.widgets) {

            let loadingDelay = 0;
            const loadingDelayInterval = self.hasCachedWidgets() ? 0 : self.widgetLoadingDelay();

            data.widgets.forEach(wdgt => {
                setTimeout(() => loadWidget(wdgt), loadingDelay);
                loadingDelay += loadingDelayInterval;
            });
        }
    }

    var loadWidget = function (w) {

        w.editMode = false;
        w.dashboard = self;
        w.dashboardsRepo = dashboardsRepo;
        w.reportsRepo = reportsRepo;
        w.isDashboardOwner = self.isDashboardOwner();
        w.editDashboardWidgetsFeatureEnabled = self.editDashboardWidgetsFeatureEnabled();

        var newWidget = new widget(w);
        self.widgets.push(newWidget);
    }

    //Init the UI
    init(data);
}
